import first from "lodash/first";
import type { FunctionComponent } from "react";

import { useSearchContext } from "~/components/search/contexts";
import { DropdownMenu } from "~/components/search/search-result-panel/components/dropdown-menu";
import {
  AllSectionsOption,
  SectionOptions,
} from "~/components/search/search-result-panel/search-result-list/advanced-filter-options/section-menu/const";

type Props = {
  className?: string;
};

export const SectionMenu: FunctionComponent<Props> = ({ className }) => {
  const { sectionIds, setSectionIds } = useSearchContext();
  const handleOnSectionChanged = (sectionEntityId: string) => {
    // At present, we need to filter for a single section
    setSectionIds?.(sectionEntityId ? [sectionEntityId] : []);
  };

  // Initially, sectionIds may be undefined, in which case we display a placeholder
  // If "All" is selected, sectionIds will be an empty array
  const selectedSectionOption = Array.isArray(sectionIds)
    ? first(sectionIds) ?? AllSectionsOption.value
    : undefined;

  return (
    <DropdownMenu
      className={className}
      options={SectionOptions}
      placeholder="Section"
      selectedOptionValue={selectedSectionOption}
      onOptionSelect={handleOnSectionChanged}
    />
  );
};

SectionMenu.displayName = "SectionMenu";
